export const regions = [
  {
    id: '1',
    name: 'North America',
    code: 'NA',
    assetsCount: 324,
    percentage: 46,
    color: 'text-blue-500'
  },
  {
    id: '2',
    name: 'Europe',
    code: 'EU',
    assetsCount: 186,
    percentage: 26,
    color: 'text-purple-500'
  },
  {
    id: '3',
    name: 'Asia Pacific',
    code: 'APAC',
    assetsCount: 142,
    percentage: 20,
    color: 'text-emerald-500'
  },
  {
    id: '4',
    name: 'South America',
    code: 'SA',
    assetsCount: 50,
    percentage: 8,
    color: 'text-yellow-500'
  }
];